export default __webpack_public_path__ + "static/media/jcb.ee928259.svg";